import React from 'react';

import EpisodeFeed from '../../Components/EpisodeFeed';

const EpisodeSpotlight = ({ episodes, loading }) => (
  <EpisodeFeed
    episodes={!loading ? filterEpisodes(episodes) : []}
    header={'Episodes'}
    loading={loading}
  />
);

const filterEpisodes = (episodes) => {
  const featuredEpisodes = [];
  const filtered = episodes.filter((episode) => episode.featured);

  // Add manually featured episodes to featured array based on listed position
  for (let i = 0; i < 12; i++) {
    const manuallyFeatured = filtered.filter(
      (episode) => Number(episode.featured) === i + 1
    )[0];

    const featuredEpisode = manuallyFeatured
      ? manuallyFeatured
      : getRandomEpisode(episodes);
    featuredEpisodes.push(featuredEpisode);
  }
  return featuredEpisodes;
};

// *** POSSIBLE DUPLICATION ISSUE WARNING ***
// This function could return the same non-featured episode multiple times.
// Ideal scenario would be to always feature as close to 12 as possible and have a wide volume of episodes available for random selection
const getRandomEpisode = (episodes) => {
  const randomIndex = getRandomIndex(episodes.length);
  if (episodes[randomIndex].featured) {
    getRandomEpisode(episodes);
  }
  return episodes[randomIndex];
};

const getRandomIndex = (max) => Math.floor(Math.random() * Math.floor(max));

export default EpisodeSpotlight;
